import { useState } from "react";

import Title from "../../LoanTermDeviation/Title";
import { SliderContainerType } from "../SliderContainer";
import Button from "../../../components/atomic/Button";

import { useUtilityStates } from "../useStates";

import { formatAndMaskMobile } from "../utils";

import { notify } from "../../../shared/context/AlertContext";
import GetAuthContext from "../../../shared/context/AuthContext";

import { LoanApplicationService } from "../../../services/LoanApplication";

export default function LeadCreated({ pageName, close }: SliderContainerType) {
  const [loading, setLoading] = useState<boolean>(false);

  const { setSidebar, customerData = {} } = useUtilityStates(
    (state) => state
  ) as any;

  const { fetchToken } = GetAuthContext();

  const sendLink = async () => {
    setLoading(true);

    try {
      const res = await LoanApplicationService?.sendSessionLinkToCustomer({
        token: fetchToken(),
        pageName,
        sourceEntityID: customerData?.sourceEntityID,
        payload: {
          userID: customerData?.userID || "",
          sourceEntityID: customerData?.sourceEntityID,
        },
      });

      if (res?.status) {
        setSidebar({ isOpen: true, current: "lead-success" });

        notify({
          title: "Success",
          type: "success",
          text: "Send Session Link to Customer",
        });
      } else
        notify({
          title: "Error",
          text: res.error,
        });
    } catch (e) {
      notify({
        title: "Error",
        text: "An unexpected error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 sm:p-10">
      <Title
        close={close}
        title="Connect to Customer"
      />

      <div className="mb-4 last:mb-0 mt-6">
        <div className="rounded-xl border p-6">
          <div className="grid gap-4 grid-cols-1 sm:grid-cols-12">
            {/* Loan Name (Mobile: Full width, Desktop: 3 columns) */}
            <div className="sm:col-span-3 text-center sm:text-left">
              <div className="text-[#101828] font-medium text-xl sm:text-2xl">
                PFL Education Loan
              </div>
              <div className="text-[#475467] text-sm font-normal mt-2.5">
                Poonawalla Education Loan
              </div>
            </div>

            {/* Customer Mobile (Mobile: Full width, Desktop: 6 columns) */}
            <div className="sm:col-span-6">
              <div className="grid grid-cols-1 sm:grid-cols-2">
                <div className="text-center">
                  <div className="text-[#343F59] font-bold text-2xl sm:text-3xl">
                    {formatAndMaskMobile(
                      customerData?.mobile || "91-XXXXXXXXXX"
                    )}
                  </div>
                  <div className="text-[#626262] text-xs font-normal mt-2.5">
                    Mobile Number
                  </div>
                </div>
              </div>
            </div>

            {/* Send Link Button (Mobile: Full width, Desktop: 3 columns, right-aligned) */}
            <div className="col-span-3 flex items-center gap-2 sm:col-span-3 sm:justify-end justify-center mt-4 sm:mt-0">
              <Button
                color="primary"
                disabled={loading}
                onClick={sendLink}
                className="text-xs font-medium w-full sm:w-auto"
              >
                Send Link
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
